import { AvailableLanguages } from '@repo/toolkit/language-types'
import { TFunction } from 'i18next'
import parsePhoneNumberFromString from 'libphonenumber-js'
import { z, ZodType } from 'zod'

export const PHONE_NUMBER_SCHEMA: (
  t: TFunction<AvailableLanguages, undefined>
) => ZodType<string> = (t) =>
  z
    .string({
      required_error: t('errors.phone.required'),
      message: t('errors.phone.required')
    })
    .trim()
    .refine(
      (phoneNumber) => {
        const parsedNumber = parsePhoneNumberFromString(phoneNumber)
        return parsedNumber?.isValid() || false
      },
      { message: t('errors.phone.invalid') }
    )
